import ConfirmModal from "server/components/Modals/ConfirmModal";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Button, useNotify, useRefresh, useRecordContext } from "react-admin";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { DormitoryCampaignStatuses } from "utils/constants";
import { dormitoryRequests } from "api/dormitoryApi";

const useCampaignTransition = () => {
  const notify = useNotify();
  const refresh = useRefresh();

  return async (url, successMessage) => {
    await dataProvider.customRequest(url, null, "PUT");
    notify(successMessage, { type: "success" });
    refresh();
  };
};

export const CampaignTransitionAction = () => {
  const record = useRecordContext();
  const runTransition = useCampaignTransition();

  if (!record) return null;

  const isDraft = record.status === DormitoryCampaignStatuses.Draft;
  const isConfirmed = record.status === DormitoryCampaignStatuses.Confirmed;

  if (!isDraft && !isConfirmed) return null;

  return (
    <SecuredComponent permission={permissions.canManageDormitoryCampaigns}>
      {isDraft ? (
        <ConfirmModal
          onConfirm={() => runTransition(dormitoryRequests.confirmCampaign(record.id), "Кампанията е потвърдена")}
          titleContent="Потвърждаване на кампания"
          message="Сигурни ли сте, че искате да потвърдите кампанията? След потвърждаване тя приема молби в рамките на срока за подаване на документи."
          triggerButton={<Button startIcon={<CheckCircleIcon />} label="Потвърди" />}
        />
      ) : (
        <ConfirmModal
          onConfirm={() => runTransition(dormitoryRequests.finishCampaign(record.id), "Кампанията е приключена")}
          titleContent="Приключване на кампания"
          message="Сигурни ли сте, че искате да приключите кампанията? Приключена кампания не може да се редактира."
          triggerButton={<Button startIcon={<DoneAllIcon />} label="Приключи" />}
        />
      )}
    </SecuredComponent>
  );
};

export const CampaignCancelAction = () => {
  const record = useRecordContext();
  const runTransition = useCampaignTransition();
  const canCancel = record?.status === DormitoryCampaignStatuses.Draft ||
    record?.status === DormitoryCampaignStatuses.Confirmed;

  if (!canCancel) return null;

  return (
    <SecuredComponent permission={permissions.canManageDormitoryCampaigns}>
      <ConfirmModal
        onConfirm={() => runTransition(dormitoryRequests.cancelCampaign(record.id), "Кампанията е отказана")}
        titleContent="Отказване на кампания"
        message="Сигурни ли сте, че искате да откажете кампанията? Отказана кампания не може да се редактира."
        triggerButton={<Button startIcon={<CancelIcon />} label="Откажи" />}
      />
    </SecuredComponent>
  );
};

const CampaignStatusActions = () => (
  <>
    <CampaignTransitionAction />
    <CampaignCancelAction />
  </>
);

export default CampaignStatusActions;
